import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";

import { Form } from "react-bootstrap";

import { ProgressBar } from "react-loader-spinner";

import { fetchWithToken } from "../../../../interceptors/fetchInterceptor";

import { clearNewStatement } from "../../../../redux/statementReducer/actionsStatement";

import { addNewStatementData } from "../../../../redux/statementReducer/actionsStatement";

import InformationAboutIndividual from "../../commonComponents/InformationAboutIndividual/InformationAboutIndividual";
import InformationAboutEntity from "../../commonComponents/InformationAboutEntity/InformationAboutEntity";
import InfoRepresentPerson from "../../commonComponents/InfoRepresentPerson/InfoRepresentPerson";

import InformationAboutBoat from "../../commonComponents/InformationAboutBoat/InformationAboutBoat";
import OtherInformation from "../../commonComponents/OtherInformation/OtherInformation";
import ResultModalWindow from "../../commonComponents/ResultModalWindow/ResultModalWindow";
import AppFooterCorrected from "../../commonComponents/AppFooterCorrected/AppFooterCorrected";
import TableAppBoatRegRHF from "../../commonComponents/tableAppBoatRegRHF/TableAppBoatRegRHF";
import QRModalWindow from "../../commonComponents/QRModalWindow/QRModalWindow";

import {
  fieldPassportOptions,
  fieldAddressOptions as addressIndividual,
  fieldAddressOptions,
} from "../../commonComponents/InformationAboutIndividual/optionsForInformationAboutIndividual";
import {
  fieldLEInformOptions,
  fieldAddressOptions as addressEntity,
  setDefaultOptions,
} from "../../commonComponents/InformationAboutEntity/optionsInformationAboutEntity";

import {
  optionSelectChangeType,
  enginesList,
  boatCardSpecmarksList,
  boatCardModifDealsDtoList,
  readStatusForInputField,
  setOptionsForModal,
  boatArrestsColumns,
  isNeedToPaySelector,
} from "./optionsForIndividualStatement";

import { customStyles } from "../../../GeneralComponents/componentsForFormUniversal/selectWithSearchUniversal/optionsSelectWithSearch";

import { v4 as uuidv4 } from "uuid";

import {
  MAIN_URL,
  PORT,
  API_GET_BOAT_CARD_FOR_MODIF,
  API_ADD_CHANGE_INFORMATION_CARD,
  API_GET_STATEMENT_MODIF_INFO,
  PORT_FOR_INTEGRATION,
  API_GET_INFO_BY_REG_NUM,
  API_GET_QR,
  API_GET_BILL,
} from "../../../../constants/constants";

import styles from "./IndividualStatement.module.css";
import { customErrorStyles } from "../../../checksAuditsComponents/addExaminationResult/constantsExaminationResultModal";

function IndividualStatement() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const mode = window.location.pathname.includes("add") ? "add" : "view";
  const {
    idBoadCard,
    idTypeStatement,
    modeView,
    idStatement,
    additionalAccess,
  } = location.state || {};
  const [idTypeChangeStatement, setIdTypeChangeStatement] = useState(2);
  const [directoryLoad, setDirectoryLoad] = useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const [showResultModal, setShowResultModal] = useState(false);
  const [newData, setNewData] = useState({});
  const [errors, setErrors] = useState({});
  const [registrationResult, setRegistrationResult] = useState("");
  const [appId, setAppId] = useState(null);
  const [saveKey, setSaveKey] = useState(false);
  const [file, setFile] = useState();
  const mainInfo =
    idTypeStatement === 1 ? fieldPassportOptions : fieldLEInformOptions;
  const addressInfo = idTypeStatement === 1 ? addressIndividual : addressEntity;
  const [errorsFields, setErrorsFields] = useState([
    ...Object.entries({ ...mainInfo, ...addressInfo })
      .filter((item) => item[1].required)
      .map((el) => el[0]),
    "ulica",
    "agentUlica",
    "agentDocDate",
    "agentPhone",
  ]);

  const [selectChangeTypeState, setSelectChangeTypeState] = useState(true);
  const [showBillContractModal, setShowBillContractModal] = useState(false);
  const [serviceBill, setServiceBill] = useState({});
  const [errorText, setErrorText] = useState("");
  const [headerText, setHeaderText] = useState("");

  const [inputsEditableState, setInputsEditableState] = useState({
    interested: "view",
    represent: "add",
    boat: "view",
    otherInfo: "view",
    tableEngine: "view",
    tableDeals: "view",
    tableSpecMarks: "view",
  });

  const handleErrorsFields = () => {
    setErrorsFields(
      structuredClone(
        Object.entries({ ...mainInfo, ...addressInfo })
          .filter((item) => item[1].required)
          .map((el) => el[0]),
      ),
    );
  };
  const engineTypes = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.allEngineTypes.map((el) => {
      return { ...el, key: "engtype" };
    });
  });
  const reduxData = useSelector((state) => {
    const { statementReducer } = state;
    return statementReducer.newStatement;
  });
  const dictionaryReducer = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer;
  });

  const handleSave = async (e) => {
    if (!handleErrors()) {
      const { surname, name, midname, phone, isNeedToPaySelector } = newData;
      const addressString = `РБ, ${
        newData["oblId"] === 5
          ? "г. Минск"
          : fieldAddressOptions.oblId.options.find(
              (item) => item.value === newData["oblId"],
            )?.label
      } ${
        newData["rayonId"]
          ? ", " +
            fieldAddressOptions.rayonId.options.find(
              (item) => item.value === newData["rayonId"],
            )?.label +
            " район"
          : ""
      } ${
        newData["gorodId"]
          ? ", " +
            fieldAddressOptions.gorodId.options.find(
              (item) => item.value === newData["gorodId"],
            )?.label
          : ""
      } ${newData["ulica"] ? ", ул. " + newData["ulica"] : ""} ${
        newData["dom"] ? ", д. " + newData["dom"] : ""
      } ${newData["korpus"] ? ", к. " + newData["korpus"] : ""} ${
        newData["kv"] ? ", кв. " + newData["kv"] : ""
      }`;

      if (!isNeedToPaySelector) {
        saveApplication();
        return;
      }

      const createdBill = await fetchWithToken(
        MAIN_URL + PORT_FOR_INTEGRATION + API_GET_BILL,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
          body: JSON.stringify({
            address: addressString,
            surname,
            name,
            midname,
            programId: null,
            phone,
            paidProcType: null,
            codeNumber: "200003",
          }),
        },
      ).then((res) => res.json());
      if (createdBill.status !== 200) {
        setErrorText(
          "Зарегистрируйте заявление без выставления счёта на оплату или попробуйте позже.",
        );
        setHeaderText(createdBill.message);
        setShowResultModal(!showResultModal);
      }

      if (createdBill.id) {
        fetchWithToken(MAIN_URL + PORT_FOR_INTEGRATION + API_GET_QR, {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
          body: JSON.stringify({
            serviceBillId: createdBill.serviceBillId,
          }),
        })
          .then((res) => res.blob())
          .then((blob) => {
            setServiceBill({
              id: createdBill.serviceBillId,
              QRurl: URL.createObjectURL(blob),
              onClose: () => {
                newData.billDataId = createdBill.id;
                saveApplication();
                setShowBillContractModal(false);
              },
            });

            setShowBillContractModal(true);
          });
      }
    } else {
      setSaveKey(true);
    }
  };

  const saveApplication = async () => {
    const formData = new FormData();
    if (file !== undefined) {
      formData.append(`file`, file);
    }
    formData.append("data", JSON.stringify(newData));
    const response = await fetchWithToken(
      MAIN_URL + PORT + API_ADD_CHANGE_INFORMATION_CARD + String(idBoadCard),
      {
        method: "POST",
        body: formData,
      },
    );

    if (response.status !== 200) {
      setShowResultModal(!showResultModal);
      setRegistrationResult("error");
    } else {
      const responseText = await response.text();
      setAppId(responseText);
      setShowResultModal(!showResultModal);
      setRegistrationResult("success");
    }
  };

  const handleLoading = (value) => {
    setIsLoading(value);
  };

  const handleOptionSelectChangeType = () => {
    setSelectChangeTypeState(false);
  };
  const validateDate = (key) => {
    if (new Date(newData[key]) > new Date()) {
      setErrors({ [key]: "Дата не может быть позже текущей" });
    } else {
      delete errors[key];
      setErrors(structuredClone(errors));
    }
  };

  // const handleErrorSearchByPersNumOrUnp = (text) => {
  //   setErrorText(text);
  //   setHeaderText("Заполните поля вручную");
  //   setShowResultModal(true);
  // };

  const createRow = () => {
    if (Array.isArray(newData?.boatArrestsList)) {
      return newData?.boatArrestsList.map((el) => {
        return (
          <>
            {el.hasOwnProperty("isActiv") && !el?.isActiv && (
              <tr>
                {Object.values(
                  boatArrestsColumns.namePropsDeactivateArrest,
                ).map((prop) => {
                  return <td id={prop.key}>{el?.[prop.key]}</td>;
                })}
              </tr>
            )}
            <tr className={el?.isActiv ? styles["red-text"] : ""}>
              {Object.values(boatArrestsColumns.nameProps).map((prop) => {
                return <td id={prop.key}>{el?.[prop.key]}</td>;
              })}
            </tr>
          </>
        );
      });
    } else {
      return (
        <tr>
          {Object.values(boatArrestsColumns.nameProps).map((prop) => {
            return (
              <td id={prop.key}>{newData?.boatArrestsList?.[prop.key]}</td>
            );
          })}
        </tr>
      );
    }
  };
  const handleErrors = () => {
    let newErrors = {};
    errorsFields.forEach((elem) => {
      switch (true) {
        case elem === "appDate":
          if (!newData[elem]) {
            newErrors[elem] = "Заполните поле";
          }
          if (new Date(newData[elem]) > new Date()) {
            newErrors[elem] = "Дата не может быть позже текущей";
          }
          break;
        case elem === "ulica" || elem === "agentUlica":
          if (newData[elem] && !/^[а-яА-ЯёЁ\s.,;:!?-]*$/.test(newData[elem])) {
            newErrors[elem] = "Заполнение на русском языке";
          }
          break;
        case elem === "docDateIssue" || elem === "agentDocDate":
          if (new Date(newData[elem]) > new Date()) {
            newErrors[elem] = "Дата не может быть позднее текущей";
          } else if (
            new Date(newData[elem]) < new Date("1996-09-26T00:00:00.000+03:00")
          ) {
            newErrors[elem] = "Дата не может быть ранее 26.09.1996";
          } else if (
            elem === "docDateIssue" &&
            !(
              new Date(newData[elem]) <
              new Date("1996-09-26T00:00:00.000+03:00")
            )
          ) {
            if (!newData[elem] || newData[elem] === "") {
              newErrors[elem] = "Заполните поле";
            }
          }
          break;
        case elem === "phone":
          if (!/^[0-9+\s,;()-]*$/.test(newData[elem])) {
            newErrors[elem] = "Введены недопустимые символы";
          } else if (!newData[elem] || newData[elem] === "") {
            newErrors[elem] = "Заполните поле";
          }
          break;
        case elem === "agentPhone":
          if (!/^[0-9+\s,;()-]*$/.test(newData[elem])) {
            newErrors[elem] = "Введены недопустимые символы";
          }
          break;
        default:
          if (!newData[elem] || newData[elem] === "") {
            newErrors[elem] = "Заполните поле";
          }
          break;
      }
    });
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return true;
    } else {
      setErrors({});
      return false;
    }
  };
  const handleCustomError = (key, text) => {
    if (text) {
      errors[key] = text;
    } else {
      delete errors[key];
    }
    setErrors(structuredClone(errors));
  };
  const handleFile = (value) => {
    setFile(value);
  };
  const updateNewData = (key, value, updateType) => {
    if (updateType === "delete") {
      const index = newData[key].findIndex((el) => el.innerId === value);
      if (index !== -1) {
        newData[key].splice(index, 1);
        setNewData({ ...newData });
        return;
      }
    }
    if (updateType === "removeEngine") {
      newData[key].find((el) => String(el.engid) === value).dateRegEnd =
        new Date().toLocaleDateString("ru");
      setNewData({ ...newData });
      return;
    }
    if (Array.isArray(newData[key]) && updateType !== "delete") {
      value.innerId = uuidv4();
      newData[key].push(value);
      setNewData({ ...newData });
    } else {
      newData[key] = value;
      setNewData({ ...newData });
    }
  };
  const handleCloseApp = (e) => {
    if (e) {
      navigate(-2);
    } else {
      navigate(-1);
    }
    dispatch(clearNewStatement());
  };
  const handleTypeChangeStatement = (e) => {
    setIdTypeChangeStatement(e.value);
    let initialData = {};
    switch (e.value) {
      case 1:
        initialData = {
          changeType: e.value,
          regNum: reduxData.regNum,
          personType: reduxData.personType,
          tiketNum: reduxData.tiketNum,
          ticketDate: reduxData.ticketDate,
          boatCardSpecmarksList: [...reduxData.boatCardSpecmarksList],
          boatCardModifDealsList: [...reduxData.boatCardModifDealsList],
          boatArrestsList: [...reduxData.boatArrestsList],
          appDate: newData.appDate,
          agentDocDate: "",
          agentDocDepartment: "",
          agentDocType: null,
          agentDom: "",
          agentDoverennost: "",
          agentGorodId: null,
          agentKorpus: "",
          agentKv: "",
          agentMidname: "",
          agentName: "",
          agentNumberOfPassport: "",
          agentOblId: null,
          agentPersNum: "",
          agentPhone: "",
          agentRayonId: null,
          agentSerialOfPassport: "",
          agentSurname: "",
          agentUlica: "",
          boatVin: "",
          boatYear: "",
          engineNum: "",
          parkingPlace: "",
          boatPayload: "",
          engpwrmax: "",
          boatLength: reduxData.boatLength,
          boatWidth: reduxData.boatWidth,
          boatHeight: reduxData.boatHeight,
          passengersNum: "",
          saCategory: null,
          boatName: "",
          boatType: null,
          boatVid: null,
          bodyMaterial: null,
          surname: "",
          name: "",
          midname: "",
          unp: reduxData.unp,
          docDepartmentLe: reduxData.docDepartmentLe,
          nameLe: reduxData.nameLe,
          egrNum: reduxData.egrNum,
          docType: null,
          serialOfPassport: "",
          numberOfPassport: "",
          persNum: "",
          docDepartment: "",
          docDateIssue: "",
          oblId: null,
          rayonId: null,
          gorodId: null,
          ulica: "",
          korpus: "",
          dom: "",
          kv: "",
          phone: "",
          enginesList: [],
          appReason: "",
          note: "",
          note2: "",
          isNeedToPaySelector: newData.isNeedToPaySelector,
        };
        setInputsEditableState({
          interested: "add",
          represent: "add",
          boat: "view",
          otherInfo: "view",
          tableEngine: "view",
          tableDeals: "view",
          tableSpecMarks: "view",
        });
        break;
      case 2:
        initialData = {
          changeType: e.value,
          regNum: reduxData.regNum,
          personType: reduxData.personType,
          tiketNum: reduxData.tiketNum,
          ticketDate: reduxData.ticketDate,
          boatCardModifDealsList: [...reduxData.boatCardModifDealsList],
          boatCardSpecmarksList: [...reduxData.boatCardSpecmarksList],
          boatArrestsList: [...reduxData.boatArrestsList],
          boatVin: reduxData.boatVin,
          boatYear: reduxData.boatYear,
          engineNum: reduxData.engineNum,
          parkingPlace: reduxData.parkingPlace,
          boatPayload: reduxData.boatPayload,
          engpwrmax: reduxData.engpwrmax,
          boatLength: reduxData.boatLength,
          boatWidth: reduxData.boatWidth,
          boatHeight: reduxData.boatHeight,
          passengersNum: reduxData.passengersNum,
          saCategory: reduxData.saCategory,
          boatName: reduxData.boatName,
          boatType: reduxData.boatType,
          boatVid: reduxData.boatVid,
          bodyMaterial: reduxData.bodyMaterial,
          surname: reduxData.surname,
          name: reduxData.name,
          midname: reduxData.midname,
          unp: reduxData.unp,
          docDepartmentLe: reduxData.docDepartmentLe,
          nameLe: reduxData.nameLe,
          egrNum: reduxData.egrNum,
          docType: reduxData.docType,
          serialOfPassport: reduxData.serialOfPassport,
          numberOfPassport: reduxData.numberOfPassport,
          persNum: reduxData.persNum,
          docDepartment: reduxData.docDepartment,
          docDateIssue: reduxData.docDateIssue,
          oblId: reduxData.oblId,
          rayonId: reduxData.rayonId,
          gorodId: reduxData.gorodId,
          ulica: reduxData.ulica,
          korpus: reduxData.korpus,
          dom: reduxData.dom,
          kv: reduxData.kv,
          phone: reduxData.phone,
          enginesList: [...reduxData.enginesList],
          appReason: "",
          note: "",
          note2: "",
          agentDocDate: "",
          agentDocDepartment: "",
          agentDocType: null,
          agentDom: "",
          agentDoverennost: "",
          agentGorodId: null,
          agentKorpus: "",
          agentKv: "",
          agentMidname: "",
          agentName: "",
          agentNumberOfPassport: "",
          agentOblId: null,
          agentPersNum: "",
          agentPhone: "",
          agentRayonId: null,
          agentSerialOfPassport: "",
          agentSurname: "",
          agentUlica: "",
          appDate: newData.appDate,
          isNeedToPaySelector: newData.isNeedToPaySelector,
        };
        setInputsEditableState({
          interested: "view",
          represent: "add",
          boat: "view",
          otherInfo: "view",
          tableEngine: "view",
          tableDeals: "view",
          tableSpecMarks: "view",
        });
        break;
      case 3:
        initialData = {
          changeType: e.value,
          regNum: reduxData.regNum,
          personType: reduxData.personType,
          tiketNum: reduxData.tiketNum,
          ticketDate: reduxData.ticketDate,
          boatCardModifDealsList: [...reduxData.boatCardModifDealsList],
          boatCardSpecmarksList: [...reduxData.boatCardSpecmarksList],
          boatArrestsList: [...reduxData.boatArrestsList],
          boatVin: reduxData.boatVin,
          boatYear: reduxData.boatYear,
          engineNum: reduxData.engineNum,
          parkingPlace: reduxData.parkingPlace,
          boatPayload: reduxData.boatPayload,
          engpwrmax: reduxData.engpwrmax,
          boatLength: reduxData.boatLength,
          boatWidth: reduxData.boatWidth,
          boatHeight: reduxData.boatHeight,
          passengersNum: reduxData.passengersNum,
          saCategory: reduxData.saCategory,
          boatName: reduxData.boatName,
          boatType: reduxData.boatType,
          boatVid: reduxData.boatVid,
          bodyMaterial: reduxData.bodyMaterial,
          surname: reduxData.surname,
          name: reduxData.name,
          midname: reduxData.midname,
          unp: reduxData.unp,
          docDepartmentLe: reduxData.docDepartmentLe,
          nameLe: reduxData.nameLe,
          egrNum: reduxData.egrNum,
          docType: reduxData.docType,
          serialOfPassport: reduxData.serialOfPassport,
          numberOfPassport: reduxData.numberOfPassport,
          persNum: reduxData.persNum,
          docDepartment: reduxData.docDepartment,
          docDateIssue: reduxData.docDateIssue,
          oblId: reduxData.oblId,
          rayonId: reduxData.rayonId,
          gorodId: reduxData.gorodId,
          ulica: reduxData.ulica,
          korpus: reduxData.korpus,
          dom: reduxData.dom,
          kv: reduxData.kv,
          phone: reduxData.phone,
          enginesList: [...reduxData.enginesList],
          appReason: "",
          note: "",
          note2: "",
          agentDocDate: "",
          agentDocDepartment: "",
          agentDocType: null,
          agentDom: "",
          agentDoverennost: "",
          agentGorodId: null,
          agentKorpus: "",
          agentKv: "",
          agentMidname: "",
          agentName: "",
          agentNumberOfPassport: "",
          agentOblId: null,
          agentPersNum: "",
          agentPhone: "",
          agentRayonId: null,
          agentSerialOfPassport: "",
          agentSurname: "",
          agentUlica: "",
          appDate: newData.appDate,
          isNeedToPaySelector: newData.isNeedToPaySelector,
        };
        setInputsEditableState({
          interested: "view",
          represent: "add",
          boat: "add",
          otherInfo: "view",
          tableEngine: "add",
          tableDeals: "view",
          tableSpecMarks: "view",
        });
        break;
      case 4:
        initialData = {
          changeType: e.value,
          regNum: reduxData.regNum,
          personType: reduxData.personType,
          tiketNum: reduxData.tiketNum,
          ticketDate: reduxData.ticketDate,
          boatCardModifDealsList: [...reduxData.boatCardModifDealsList],
          boatCardSpecmarksList: [...reduxData.boatCardSpecmarksList],
          boatArrestsList: [...reduxData.boatArrestsList],
          boatVin: reduxData.boatVin,
          boatYear: reduxData.boatYear,
          engineNum: reduxData.engineNum,
          parkingPlace: reduxData.parkingPlace,
          boatPayload: reduxData.boatPayload,
          engpwrmax: reduxData.engpwrmax,
          boatLength: reduxData.boatLength,
          boatWidth: reduxData.boatWidth,
          boatHeight: reduxData.boatHeight,
          passengersNum: reduxData.passengersNum,
          saCategory: reduxData.saCategory,
          boatName: reduxData.boatName,
          boatType: reduxData.boatType,
          boatVid: reduxData.boatVid,
          bodyMaterial: reduxData.bodyMaterial,
          surname: reduxData.surname,
          name: reduxData.name,
          midname: reduxData.midname,
          docType: reduxData.docType,
          serialOfPassport: reduxData.serialOfPassport,
          numberOfPassport: reduxData.numberOfPassport,
          persNum: reduxData.persNum,
          docDepartment: reduxData.docDepartment,
          docDateIssue: reduxData.docDateIssue,
          oblId: reduxData.oblId,
          rayonId: reduxData.rayonId,
          gorodId: reduxData.gorodId,
          ulica: reduxData.ulica,
          korpus: reduxData.korpus,
          dom: reduxData.dom,
          kv: reduxData.kv,
          phone: reduxData.phone,
          unp: reduxData.unp,
          docDepartmentLe: reduxData.docDepartmentLe,
          nameLe: reduxData.nameLe,
          egrNum: reduxData.egrNum,
          enginesList: [],
          appReason: "",
          note: "",
          note2: "",
          agentDocDate: "",
          agentDocDepartment: "",
          agentDocType: null,
          agentDom: "",
          agentDoverennost: "",
          agentGorodId: null,
          agentKorpus: "",
          agentKv: "",
          agentMidname: "",
          agentName: "",
          agentNumberOfPassport: "",
          agentOblId: null,
          agentPersNum: "",
          agentPhone: "",
          agentRayonId: null,
          agentSerialOfPassport: "",
          agentSurname: "",
          agentUlica: "",
          appDate: newData.appDate,
          isNeedToPaySelector: newData.isNeedToPaySelector,
        };
        setInputsEditableState({
          interested: "add",
          represent: "add",
          boat: "view",
          otherInfo: "add",
          tableEngine: "view",
          tableDeals: "view",
          tableSpecMarks: "add",
        });
        break;
      default:
        initialData = {};
        break;
    }
    setNewData(initialData);
  };
  useEffect(() => {
    if (directoryLoad) {
      setOptionsForModal(engineTypes);
    }
  }, [directoryLoad]);
  useEffect(() => {
    if (Boolean(engineTypes.length) && !directoryLoad) {
      setDirectoryLoad(true);
    }
  }, [engineTypes]);
  useEffect(() => {
    async function fetchData() {
      if (
        window.location.pathname.includes("/reginformationchanges/statement")
      ) {
        const responseStatement = await fetchWithToken(
          MAIN_URL + PORT + API_GET_STATEMENT_MODIF_INFO + String(idStatement),
        );
        const dataStatement = await responseStatement.json();
        setNewData(dataStatement);
        setIdTypeChangeStatement(String(dataStatement.changeType));
      } else {
        const responseBoatCard = await fetchWithToken(
          MAIN_URL + PORT + API_GET_BOAT_CARD_FOR_MODIF + String(idBoadCard),
        );
        const dataBoatCard = await responseBoatCard.json();
        dispatch(addNewStatementData(dataBoatCard));
        setNewData({
          changeType: 2,
          regNum: dataBoatCard.regNum,
          personType: dataBoatCard.personType,
          tiketNum: dataBoatCard.tiketNum,
          ticketDate: dataBoatCard.ticketDate,
          boatCardModifDealsList: [...dataBoatCard.boatCardModifDealsList],
          boatCardSpecmarksList: [...dataBoatCard.boatCardSpecmarksList],
          boatArrestsList: [...dataBoatCard.boatArrestsList],
          boatVin: dataBoatCard.boatVin,
          boatYear: dataBoatCard.boatYear,
          engineNum: dataBoatCard.engineNum,
          parkingPlace: dataBoatCard.parkingPlace,
          boatPayload: dataBoatCard.boatPayload,
          engpwrmax: dataBoatCard.engpwrmax,
          boatLength: dataBoatCard.boatLength,
          boatWidth: dataBoatCard.boatWidth,
          boatHeight: dataBoatCard.boatHeight,
          passengersNum: dataBoatCard.passengersNum,
          saCategory: dataBoatCard.saCategory,
          boatName: dataBoatCard.boatName,
          boatType: dataBoatCard.boatType,
          boatVid: dataBoatCard.boatVid,
          bodyMaterial: dataBoatCard.bodyMaterial,
          surname: dataBoatCard.surname,
          name: dataBoatCard.name,
          midname: dataBoatCard.midname,
          unp: dataBoatCard.unp,
          docDepartmentLe: dataBoatCard.docDepartmentLe,
          nameLe: dataBoatCard.nameLe,
          egrNum: dataBoatCard.egrNum,
          docType: dataBoatCard.docType,
          serialOfPassport: dataBoatCard.serialOfPassport,
          numberOfPassport: dataBoatCard.numberOfPassport,
          persNum: dataBoatCard.persNum,
          docDepartment: dataBoatCard.docDepartment,
          docDateIssue: dataBoatCard.docDateIssue,
          oblId: dataBoatCard.oblId,
          rayonId: dataBoatCard.rayonId,
          gorodId: dataBoatCard.gorodId,
          ulica: dataBoatCard.ulica,
          korpus: dataBoatCard.korpus,
          dom: dataBoatCard.dom,
          kv: dataBoatCard.kv,
          phone: dataBoatCard.phone,
          enginesList: [...dataBoatCard.enginesList],
          appReason: "",
          note: "",
          note2: "",
          agentDocDate: "",
          agentDocDepartment: "",
          agentDocType: null,
          agentDom: "",
          agentDoverennost: "",
          agentGorodId: null,
          agentKorpus: "",
          agentKv: "",
          agentMidname: "",
          agentName: "",
          agentNumberOfPassport: "",
          agentOblId: null,
          agentPersNum: "",
          agentPhone: "",
          agentRayonId: null,
          agentSerialOfPassport: "",
          agentSurname: "",
          agentUlica: "",
          appDate: new Date()
            .toLocaleDateString()
            .split(".")
            .reverse()
            .join("-"),
          isNeedToPaySelector: false,
        });
      }
      setIsLoading(false);
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (Object.values(dictionaryReducer.userInfo).length > 0) {
      newData["inspector"] = dictionaryReducer.userInfo.userid;
      setNewData(structuredClone(newData));
    }
  }, [dictionaryReducer.userInfo]);
  useEffect(() => {
    if (!newData["inspector"]) {
      newData["inspector"] = dictionaryReducer.userInfo.userid;
      setNewData(structuredClone(newData));
    }
  }, [newData]);

  useEffect(() => {
    return () => {
      setDefaultOptions();
    };
  }, []);

  const checkViewButton = () => {
    if (mode === "view") {
      return false;
    }
    let b = !!newData.boatCardSpecmarksList
      ? !newData.boatCardSpecmarksList.find((el) => el.msmLock === true)
      : true;
    let d = !!newData.boatArrestsList
      ? !newData.boatArrestsList.find((el) => el.isActiv === true)
      : true;
    let c = idTypeChangeStatement === 1;
    return c || (b && d);
  };
  if (isLoading) {
    return (
      <div className={"d-flex flex-column align-items-center"}>
        <ProgressBar
          height="80"
          width="1130px"
          ariaLabel="progress-bar-loading"
          wrapperStyle={{}}
          wrapperClass="progress-bar-wrapper"
          borderColor="#D2AF8E"
          barColor="#BC8653"
        />
      </div>
    );
  }

  return (
    <div className={styles["content-container"]}>
      <h2 className={styles["main-text"]}>Заявление</h2>
      <p className={styles["secondary-text"]}>
        {idTypeStatement === 1
          ? "о регистрации изменений сведений, подлежащих внесению в судовую книгу для маломерного судна, за исключением гребных лодок, байдарок и надувных судов грузоподъемностью менее 225 килограммов"
          : "о регистрации изменения сведений, подлежащих внесению в судовую книгу"}
      </p>
      <div className={styles["form-container"]}>
        <Form>
          <div className={styles["header"]}>
            {newData.boatCardSpecmarksList?.find((el) => el.msmLock === true) &&
              idTypeChangeStatement !== 1 && (
                <p className={"text-danger"}>
                  На данное судно наложено(ы) ограничения!!!
                </p>
              )}
            {newData.boatArrestsList?.find((el) => el.isActiv === true) &&
              idTypeChangeStatement !== 1 && (
                <p className={"text-danger"}>
                  На данное судно наложен(ы) аресты!!!
                </p>
              )}
            {mode !== "view" && selectChangeTypeState ? (
              <Form.Group className={styles["header-input"]}>
                <label className={styles["label"]}>
                  Какие изменения вносятся:
                </label>
                <Select
                  noOptionsMessage={() => "Нет данных"}
                  classNamePrefix="react-select"
                  id={"idTypeChangeStatement"}
                  isDisabled={mode === "view"}
                  isSearchable={false}
                  value={optionSelectChangeType?.find(
                    (item) => item.value === idTypeChangeStatement,
                  )}
                  onChange={(e) => handleTypeChangeStatement(e)}
                  placeholder={"Выберите"}
                  options={optionSelectChangeType}
                  styles={customStyles}
                />
              </Form.Group>
            ) : (
              <div className={styles["text-block"]}>
                <p className={styles["option-label"]}>
                  Какие изменения вносятся
                </p>
                <p className={styles["option-value"]}>
                  {
                    optionSelectChangeType?.find(
                      (item) =>
                        item.value === idTypeChangeStatement ||
                        item.value === newData.changeType,
                    )?.label
                  }
                </p>
              </div>
            )}

            <div className={styles["text-block"]}>
              <p className={styles["option-label"]}>
                Регистрационный номер маломерного судна
              </p>
              <p className={styles["option-value"]}>{newData.regNum}</p>
            </div>
            <div className={styles["text-block"]}>
              <p className={styles["option-label"]}>Субъект хозяйствования</p>
              <p className={styles["option-value"]}>{newData.personType}</p>
            </div>
            <div className={styles["text-block"]}>
              <p className={styles["option-label"]}>Номер судового билета</p>
              <p className={styles["option-value"]}>{newData.tiketNum}</p>
            </div>
            <div className={styles["text-block"]}>
              <p className={styles["option-label"]}>
                Дата выдачи судового билета
              </p>
              <p className={styles["option-value"]}>{newData.ticketDate}</p>
            </div>
          </div>
          {idTypeStatement === 1 ? (
            <InformationAboutIndividual
              inputData={newData}
              updateNewData={updateNewData}
              saveKey={saveKey}
              handleErrors={handleErrors}
              errors={errors}
              setErrorsFields={handleErrorsFields}
              mode={mode === "view" ? mode : inputsEditableState.interested}
              handleSearchButton={handleLoading}
              handleCustomError={handleCustomError}
              handleOptionSelectChangeType={handleOptionSelectChangeType}
            />
          ) : (
            <InformationAboutEntity
              inputData={newData}
              updateNewData={updateNewData}
              saveKey={saveKey}
              handleErrors={handleErrors}
              errors={errors}
              setErrorsFields={handleErrorsFields}
              mode={mode === "view" ? mode : inputsEditableState.interested}
              handleSearchButton={handleLoading}
              handleCustomError={handleCustomError}
              handleOptionSelectChangeType={handleOptionSelectChangeType}
            />
          )}

          <InfoRepresentPerson
            inputData={newData}
            updateNewData={updateNewData}
            mode={mode}
            saveKey={saveKey}
            handleErrors={handleErrors}
            errors={errors}
            handleSearchButton={handleLoading}
            handleCustomError={handleCustomError}
          />
          {idTypeChangeStatement !== 1 && idTypeChangeStatement !== 4 ? (
            <InformationAboutBoat
              dataBoat={newData}
              updateNewData={updateNewData}
              saveKey={saveKey}
              handleErrors={handleErrors}
              errors={errors}
              mode={mode === "view" ? mode : inputsEditableState.boat}
            />
          ) : (
            ""
          )}
          {idTypeChangeStatement === 4 ? (
            <OtherInformation
              inputData={newData}
              updateNewData={updateNewData}
              errors={errors}
              mode={mode === "view" ? mode : inputsEditableState.otherInfo}
            />
          ) : (
            ""
          )}
          <>
            <h3 className={styles["component-caption"]}>
              Основание для внесения изменений
            </h3>
            <div className={styles["container-information"]}>
              <Form.Group className={styles["appreason-block"]}>
                <label className={styles["label"]}>Основание</label>
                <input
                  id="appReason"
                  type="text"
                  placeholder={modeView !== "view" && "Введите"}
                  className={styles["form-input"]}
                  value={newData.appReason}
                  onChange={(e) =>
                    updateNewData(e.target.id, e.currentTarget.value)
                  }
                  disabled={modeView === "view" ? true : false}
                />
              </Form.Group>
            </div>
          </>

          {(idTypeChangeStatement === 2 || idTypeChangeStatement === 3) && (
            <TableAppBoatRegRHF
              addAccess={additionalAccess?.addEngine}
              tableOptions={enginesList}
              mainData={newData}
              dataForTable={newData.enginesList}
              typeTable="boatCardAppEngList"
              updateData={updateNewData}
              mode={mode === "view" ? mode : inputsEditableState.tableEngine}
            />
          )}

          {(idTypeChangeStatement === 1 || idTypeChangeStatement === 2) && (
            <TableAppBoatRegRHF
              addAccess={additionalAccess?.ownershipInformation}
              tableOptions={boatCardModifDealsDtoList}
              mainData={newData}
              dataForTable={newData.boatCardModifDealsList}
              typeTable="boatCardAppDealsList"
              updateData={updateNewData}
              mode={mode === "view" ? mode : inputsEditableState.tableDeals}
            />
          )}
          <>
            {mode === "add" && (
              <div>
                <p className={styles[boatArrestsColumns.classNameCaption]}>
                  {boatArrestsColumns.caption}
                </p>
                <table
                  className={`${styles[boatArrestsColumns.classNameTable]} ${
                    styles["table-container"]
                  }`}
                >
                  <thead>
                    <tr>
                      {Object.values(boatArrestsColumns.nameProps).map(
                        (item) => {
                          return <th id={item.key}>{item.value}</th>;
                        },
                      )}
                    </tr>
                  </thead>
                  <tbody>{createRow()}</tbody>
                </table>
              </div>
            )}
          </>
          <TableAppBoatRegRHF
            addAccess={additionalAccess?.specMarks}
            tableOptions={boatCardSpecmarksList}
            mainData={newData}
            dataForTable={newData.boatCardSpecmarksList}
            typeTable="boatCardAppSpecMarkList"
            updateData={updateNewData}
            mode={mode === "view" ? mode : inputsEditableState.tableSpecMarks}
          />
          {idTypeStatement === 1 && mode === "add" && (
            <div className={styles["exam-type-block"]}>
              <Form.Group>
                <label className={styles["label"]}>
                  {isNeedToPaySelector.label}
                </label>
                <Select
                  noOptionsMessage={() => "Нет данных"}
                  onChange={(e) => updateNewData(e.key, e.value)}
                  defaultValue={newData[isNeedToPaySelector.key]}
                  value={isNeedToPaySelector.options.find(
                    (item) => item.value === newData[isNeedToPaySelector.key],
                  )}
                  styles={
                    mode !== "view" && !!errors[isNeedToPaySelector.key]
                      ? customErrorStyles
                      : customStyles
                  }
                  classNamePrefix="select"
                  placeholder={mode !== "view" && "Выберите"}
                  id={isNeedToPaySelector.key}
                  isDisabled={mode === "view" ? true : false}
                  isSearchable={isNeedToPaySelector.isSearchable}
                  name={isNeedToPaySelector.key}
                  options={isNeedToPaySelector.options}
                />
              </Form.Group>
            </div>
          )}

          <AppFooterCorrected
            mode={modeView}
            handleFile={handleFile}
            updateNewData={updateNewData}
            errors={errors}
            inputData={newData}
          />
        </Form>
      </div>
      <div className={styles.buttons_container}>
        <div
          id="close"
          className={styles["close-btn"]}
          onClick={() => {
            handleCloseApp();
          }}
        >
          {"Закрыть"}
        </div>
        {checkViewButton() && (
          <div
            id="save"
            className={styles["save-btn"]}
            onClick={(e) => handleSave(e)}
          >
            {"Зарегистрировать"}
          </div>
        )}
      </div>
      {showBillContractModal && (
        <QRModalWindow
          show={showBillContractModal}
          setShow={setShowBillContractModal}
          billId={serviceBill.id}
          billQRurl={serviceBill.QRurl}
          onClose={serviceBill.onClose}
        />
      )}
      {showResultModal && (
        <ResultModalWindow
          appId={appId}
          show={showResultModal}
          setShow={setShowResultModal}
          result={registrationResult}
          handleCloseApp={handleCloseApp}
          errorText={errorText}
          headerTextExternal={headerText}
        />
      )}
    </div>
  );
}

export default IndividualStatement;
